import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  user;

  constructor(public router: Router, private authService: AuthService) {
    this.user = this.authService.currentUser.value;
    //console.log(this.user.userProfileId);
    
  }

  ngOnInit(): void {
    if (this.user.userProfileId == 3)
      this.router.navigate(['dashboard/client'], { queryParams: {} });
    else if (this.user.userProfileId == 2)
      this.router.navigate(['dashboard/user'], { queryParams: {} });
    else
      this.router.navigate(['dashboard/admin'], { queryParams: {} });
  }

}
